import React from 'react';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';

import Base from '../Base';

const useStyles = makeStyles(() => ({
  bold: {
    fontWeight: 800,
  },
}))


function ShootoutShotMissedEvent({event, teams, players}) {
  const classes = useStyles();
  const player = players[event.player];
  const team = teams[player.team].id;
  
  return (
    <Base
      team={team}
      type="Shootout Miss"
    >
      <Typography variant="body2">
        Shootout attempt by{' '}
        <span className={classes.bold}>{player.name}</span>
        {' '}has missed the net.
      </Typography>
    </Base>
  )
}

export default ShootoutShotMissedEvent;
